module.exports = __webpack_public_path__ + "img/22.c799fe8.png";